import { RefreshCw } from "lucide-react"

const CHIPS: { label: string; prompt: string }[] = [
  { label: "Kuerzer", prompt: "Mach den Draft kuerzer, maximal 3 Saetze." },
  { label: "Freundlicher", prompt: "Formuliere freundlicher und persoenlicher." },
  { label: "Foermlicher", prompt: "Formuliere foermlicher und formelhafter." },
  { label: "Andere Uhrzeit", prompt: "Die bisherigen Slot-Vorschlaege sind inzwischen belegt — schlage komplett neue Termine an spaeteren Tagen vor (NICHT die Daten aus dem letzten Plan wiederholen). Nimm nur freie Slots aus VERFUEGBARE SLOTS unten." },
  { label: "Neue Version", prompt: "Schreibe eine komplett andere Version der Antwort." },
]

export function QuickActionChips({
  onTrigger,
  pending,
}: {
  onTrigger: (prompt: string) => void
  pending: boolean
}) {
  return (
    // `display: contents` statt eines eigenen Kastens: Die Chips werden
    // damit zu direkten Nachbarn von Terminanzahl und Anhang-Knopf und
    // umbrechen gemeinsam mit ihnen. Vorher war diese Gruppe ein Block,
    // der den Rest der Zeile in die naechste Zeile drueckte, obwohl
    // rechts noch Platz war.
    <div style={{ display: "contents" }}>
      {CHIPS.map((c) => (
        <button
          key={c.label}
          type="button"
          disabled={pending}
          onClick={() => onTrigger(c.prompt)}
          style={{
            display: "inline-flex", alignItems: "center", gap: 4,
            background: "#fff", border: "0.5px solid rgba(44,44,42,0.15)",
            borderRadius: 999, padding: "5px 10px", fontSize: 12, color: "#2C2C2A",
            cursor: pending ? "not-allowed" : "pointer", opacity: pending ? 0.5 : 1,
          }}
          onMouseEnter={(e) => { if (!pending) e.currentTarget.style.background = "#F5F4F0" }}
          onMouseLeave={(e) => { if (!pending) e.currentTarget.style.background = "#fff" }}
        >
          <RefreshCw size={10} />
          {c.label}
        </button>
      ))}
    </div>
  )
}
